import { createFileRoute } from "@tanstack/react-router";
import PrivacyPolicy from "@/pages/PrivacyPolicy";

export const Route = createFileRoute("/_app/privacy-policy")({
  head: () => ({
    meta: [
      { title: "Privacy policy | Byteline" },
      {
        name: "description",
        content:
          "What information Byteline collects, how cookies and analytics are used, and how to contact us about your data.",
      },
      { property: "og:title", content: "Privacy policy | Byteline" },
      {
        property: "og:description",
        content: "How Byteline handles your information, cookies and third-party services.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => <PrivacyPolicy />,
});
